import { Button, Stack, TextField, Typography, Box, Link } from "@mui/material";
import {NavigateFunction, useLocation, useNavigate} from "react-router";
import { useState } from "react";
import { appSession } from "../TR3AD.ts";
import { appStyles } from "../AppStyles.ts";
import {NetworkViewState} from "./network/UXNetworkSelect.tsx";

export type LoginViewState = {
    username: string | undefined;
    networkKey: string | undefined;
    redirectURL: string | undefined;
}

function UXLogin() {
    const location = useLocation();
    const viewState = location.state as LoginViewState | null;

    const navigate: NavigateFunction = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    function onRegister() {
        navigate("/register");
    }
    function onForgotPassword() {
        navigate("/reset");
    }
    function onLogin() {
        appSession.login(username, password, (success: boolean, message: string) => {
            if (success) {
                console.info("Login successful! Navigating to connect");
                const netState: NetworkViewState = {
                    autoConnect: (viewState?.networkKey !== null),
                    networkUID: viewState?.networkKey,
                    redirectURL: viewState?.redirectURL
                }
                navigate("/networks", {
                    state: netState,
                });
            } else {
                console.info("Login Failed: " + message);
            }
        });
    }

    return (
        <Box sx={appStyles.loginContainer}>
            <Box sx={appStyles.loginOverlay} />
            <Box sx={appStyles.loginImageZone}>
                <Box sx={appStyles.loginGlass}>
                    <Stack direction="column" spacing={2} width="100%" maxWidth={320}>
                        <img src="/tr3ad_intelligence_logo_name.svg" height={64} />
                        <Typography sx={appStyles.formHeaderLabel}>
                            Log in to your account
                        </Typography>
                        <TextField
                            type="text"
                            label="Username"
                            value={username}
                            autoComplete="username"
                            onChange={(event) => setUsername(event.target.value)}
                            fullWidth
                            sx={{ mb: 2 }}
                        />
                        <TextField
                            type="password"
                            label="Password"
                            value={password}
                            autoComplete="current-password"
                            onChange={(event) => setPassword(event.target.value)}
                            fullWidth
                            sx={{ mb: 1 }}
                        />
                        <Box textAlign="right" mb={2}>
                            <Link
                                component="button"
                                variant="body2"
                                underline="hover"
                                sx={{ color: "#02CFEE", fontWeight: 500 }}
                                onClick={onForgotPassword}
                            >
                                Forgot Password?
                            </Link>
                        </Box>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={onLogin}
                            fullWidth
                            sx={{ fontWeight: 600, mt: 1 }}
                        >
                            Login
                        </Button>
                        <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
                            <Typography variant="body2" sx={{ mr: 1, color: "#b6bfce" }}>
                                Not registered?
                            </Typography>
                            <Button
                                variant="text"
                                onClick={onRegister}
                                sx={{ color: "#38ff82", fontWeight: 600, textTransform: "none", p: 0, minWidth: 0 }}
                            >
                                Register
                            </Button>
                        </Box>
                    </Stack>
                </Box>
            </Box>
        </Box>
    );
}

export default UXLogin;
